// import React from "react"
import { Route, Routes } from "react-router-dom"
import { Box } from "@mui/material"
import Header from "./components/Header"
import Home from "./components/Home.js"
import About from "./components/About.js"
import Services from "./components/Services"
import Footer from "./components/Footer"
import Contact from "./components/Contact"
import Thankyou from "./components/Thankyou";

function App() {
  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        margin: 0,
        padding: 0,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#F5F5F5",
          zIndex: -1
        }
      }}
    >
      <Header />
      <Box sx={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thankyou" element={<Thankyou />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  )
}

export default App